// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import carNumInput from '@/template/carNumInput'//自定义车牌输入及专用键盘组件
import api from '@/http/api.js'
import request from '@/http/request.js'
import axios from 'axios';
import getOpenid from '@/utils/wxUtils'
import jsSDK from '@/utils/wxPay'
Vue.prototype.$WXjsSDK = jsSDK
Vue.prototype.$getOpenid = getOpenid
import moneyFormat from '@/utils/moneyFormat.js'
import uploadImg from '@/http/uploadImg.js'


Vue.prototype.$uploadImg = uploadImg



Vue.prototype.$http = request
Vue.prototype.$api=api
Vue.prototype.$axios = axios;
//vant start
import { NavBar } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { Icon } from 'vant';
import { List } from 'vant';
import { Search } from 'vant';
import { SwipeCell } from 'vant';
import { Button } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { Popup } from 'vant';
import { Grid, GridItem } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { ImagePreview } from 'vant';
import { Image } from 'vant';
import { Circle } from 'vant';
import { Field } from 'vant';
import { Uploader } from 'vant';
import { Radio} from 'vant';
import { RadioGroup} from 'vant';
import { Notify } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { DatetimePicker } from 'vant';
import { Tag } from 'vant';
import { NoticeBar } from 'vant';
import { Divider } from 'vant';
import { Tab, Tabs } from 'vant';
import { PullRefresh } from 'vant';
import { Toast } from 'vant';
import { Step, Steps } from 'vant';
import { Dialog } from 'vant';
import { Col, Row } from 'vant';
import {Card} from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Loading } from 'vant';
import { CouponCell, CouponList } from 'vant';



// 全局注册
Vue.use(CouponCell);
Vue.use(CouponList);
Vue.use(Loading);
Vue.use(Col);
Vue.use(Row);
Vue.use(Dialog);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Toast);
Vue.use(PullRefresh);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Divider);
Vue.use(NoticeBar);
Vue.use(Tag);
Vue.use(DatetimePicker);
Vue.use(DropdownMenu).use(DropdownItem);
Vue.use(Notify);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Uploader);
Vue.use(Field);
Vue.use(Circle);
Vue.use(Image);
Vue.use(ImagePreview);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Grid).use(GridItem);
Vue.use(Popup);
Vue.use(Collapse).use(CollapseItem);
Vue.use(Cell).use(CellGroup);
Vue.use(Button);
Vue.use(SwipeCell);
Vue.use(Search);
Vue.use(List);
Vue.use(Icon);
Vue.use(Tabbar).use(TabbarItem);
Vue.use(NavBar);
Vue.use(Card);
//vant end
//ElementUI
Vue.use(ElementUI);


Vue.config.productionTip = false

Vue.component('carNum-input',carNumInput);
Vue.prototype.$moneyFormat = moneyFormat;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js